import {lazy} from 'react';

export const FundTextAppLazy = lazy(() => import(/* webpackChunkName: "fundTextApp" */ './fundTextApp'));
export const FundTableAppLazy = lazy(() => import(/* webpackChunkName: "fundTableApp" */ './fundTableApp'));
export const FundHeaderAppLazy = lazy(() => import(/* webpackChunkName: "fundHeaderApp" */ './fundHeaderApp'));
export const FundDocumentAppLazy = lazy(() => import(/* webpackChunkName: "fundDocumentApp" */ './fundDocumentApp'));
export const FundStructureChartAppLazy = lazy(() => import(/* webpackChunkName: "fundStructuredChartApp" */ './fundStructuredChartApp'));
export const FundChartAppLazy = lazy(() => import(/* webpackChunkName: "fundChartApp" */ './fundChartApp'));
export const FundBoxAppLazy = lazy(() => import(/* webpackChunkName: "fundBoxApp" */ './fundBoxApp'));
